// extracted by mini-css-extract-plugin
export default {"stickyShare":"socialMediaShare_stickyShare__v0Lg-","shareIcon":"socialMediaShare_shareIcon__eXtov","icons":"socialMediaShare_icons__5sZwc"};